import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel, { consts } from 'react-elastic-carousel';
import Button from '../components/Button';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "renderarrow"
    }}>{`renderArrow`}</h1>
    <h3 {...{
      "id": "you-can-provide-custom-arrow-buttons"
    }}>{`You can provide custom Arrow buttons.`}</h3>
    <h2 {...{
      "id": "signature"
    }}>{`Signature`}</h2>
    <ul>
      <li parentName="ul">{`You can pass a function that returns a react element,`}<br parentName="li"></br>
        {`This function is a `}<a parentName="li" {...{
          "href": "https://reactjs.org/docs/render-props.html"
        }}>{`render prop`}</a>{` and its signature is:  `}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`({type, onClick, isEdge}) => {/* return your element here */}
`}</code></pre>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`type`}</inlineCode>{` will be either `}<inlineCode parentName="li">{`consts.PREV`}</inlineCode>{` or `}<inlineCode parentName="li">{`consts.NEXT`}</inlineCode>{`, depends on the relevant arrow direction.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`onClick`}</inlineCode>{` Is the hook to the inner `}<inlineCode parentName="li">{`onClick`}</inlineCode>{` of the `}<inlineCode parentName="li">{`Carousel`}</inlineCode>{`. You can attach it wherever you want within the returned component.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`isEdge`}</inlineCode>{` Will be true when there are no more items to show for this direction.`}</li>
    </ul>
    <p><em parentName="p">{`You should import the `}<inlineCode parentName="em">{`consts`}</inlineCode>{` object to check the arrow direction`}</em></p>
    <pre><code parentName="pre" {...{}}>{`import Carousel, { consts } from 'react-elastic-carousel';
 // ....

type === consts.PREV
`}</code></pre>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <Playground __position={0} __code={'class App extends React.Component {\n    myArrow({ type, onClick, isEdge }) {\n      const pointer = type === consts.PREV ? \'👈\' : \'👉\'\n      return (\n        <Button onClick={onClick} disabled={isEdge}>\n          {pointer}\n        </Button>\n      )\n    }\n    render() {\n      return (\n        <div>\n          <Carousel renderArrow={this.myArrow}>\n            <Item>1</Item>\n            <Item>2</Item>\n            <Item>3</Item>\n            <Item>4</Item>\n            <Item>5</Item>\n            <Item>6</Item>\n          </Carousel>\n        </div>\n      )\n    }\n  }'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      consts,
      Button,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {class App extends React.Component {
        myArrow({
          type,
          onClick,
          isEdge
        }) {
          const pointer = type === consts.PREV ? '👈' : '👉';
          return <Button onClick={onClick} disabled={isEdge} mdxType="Button">
                        {pointer}
                    </Button>;
        }

        render() {
          return <div>
                        <Carousel renderArrow={this.myArrow} mdxType="Carousel">
                            <Item mdxType="Item">1</Item>
                            <Item mdxType="Item">2</Item>
                            <Item mdxType="Item">3</Item>
                            <Item mdxType="Item">4</Item>
                            <Item mdxType="Item">5</Item>
                            <Item mdxType="Item">6</Item>
                        </Carousel>
                    </div>;
        }

      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      